<div [class.open]="isOpen" class="custom-accordion-item hide-scroll-bar">

  <div #headerRef
    (click)="canToggle === true ? toggle() : null"
    [ngClass]="class ? class : ''"
    class="accordion-header">
    <ng-content select=".header"></ng-content>
  </div>

  @if (isOpen) {
    <div class="accordion-body">
      <ng-content select=".body"></ng-content>
    </div>
  }

</div>
